import type { PanInfo, Variants } from 'framer-motion'

export const MOBILE_SHEET_DISMISS_THRESHOLD_PX = 120
export const MOBILE_SHEET_DRAG_LIMIT_PX = 250

export const getAdaptiveSheetVariants = (isMobileViewport: boolean): Variants =>
  isMobileViewport
    ? {
        hidden: { y: '100%', x: 0 },
        visible: { y: 0, x: 0, transition: { type: 'spring', damping: 25, stiffness: 200 } },
        exit: { y: '100%', x: 0 },
      }
    : {
        hidden: { x: '100%', y: 0 },
        visible: { x: 0, y: 0, transition: { type: 'spring', damping: 28, stiffness: 220 } },
        exit: { x: '100%', y: 0 },
      }

export const shouldDismissMobileSheet = (isMobileViewport: boolean, info: PanInfo) =>
  isMobileViewport && info.offset.y > MOBILE_SHEET_DISMISS_THRESHOLD_PX
